import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, of, switchMap } from 'rxjs'
import { CountrySpecApiService } from './country-spec-api.service'
import * as CountrySpecActions from './country-spec.actions'
import { CountrySpecEntity } from './country-spec.models'

@Injectable()
export class CountrySpecEffects {
  private actions$ = inject(Actions)

  loadCountrySpec$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountrySpecActions.loadCountrySpec),
      switchMap((action) => {
        return this.countrySpecApiService.getCountrySpec().pipe(
          map((response: CountrySpecEntity[]) => {
            return CountrySpecActions.loadCountrySpecSuccess({
              countrySpec: response,
            })
          }),
          catchError((error) => {
            return of(CountrySpecActions.loadCountrySpecFailure({ error }))
          }),
        )
      }),
    ),
  )

  constructor(private countrySpecApiService: CountrySpecApiService) {}
}
